var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import unlockAcademics from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_academics_full.png';
import unlockAchievement from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_achievement_full.png';
import unlockCommunities from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_communities_full.png';
import unlockSkills from '@backrs_ui/common-ui/src/assets/images/unlocks/unlock_skills_full.png';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography } from '@mui/material';
export var COLUMN_WIDTH = '200px';
export var NAME_COLUMN_WIDTH = '140px';
export var IMAGE_COLUMN_WIDTH = '220px';
var MIN_HEIGHT = '100px';
export var CATEGORY_IMAGES = {
    'academic-foundations': unlockAcademics,
    'real-world-experience': unlockAchievement,
    'mindsets-and-skills': unlockSkills,
    'community-of-success': unlockCommunities,
    none: '',
};
export var UnlockItem = function (_a) {
    var category = _a.category, strengths = _a.strengths, opportunitiesToGrow = _a.opportunitiesToGrow, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b, _c = _a.isEmptyState, isEmptyState = _c === void 0 ? false : _c;
    var image = CATEGORY_IMAGES[category.slug];
    return (_jsxs(Box, { sx: unlockItemContainerSx(isMobile, isEmptyState), children: [_jsx(Box, { sx: imageContainerSx(isMobile), children: _jsx(Box, { component: "img", src: image, alt: category.name, sx: unlockItemImageSx(isMobile, isEmptyState) }) }), _jsxs(Box, { sx: tableContainerSx(isMobile), children: [_jsx(Box, { sx: categoryColumnSx(isMobile, isEmptyState), children: !isEmptyState && (_jsx(Typography, { variant: "text-sm-regular", sx: unlockItemTitleSx, children: category.name })) }), _jsx(Box, { sx: sectionContainerSx(isMobile, isEmptyState), children: !isEmptyState &&
                            strengths.map(function (strength, index) { return (_jsxs(Box, { sx: itemContainerSx, children: [_jsx(Box, { sx: iconContainerStrengthSx, children: _jsx(AppIcon, { iconName: "Check", diameter: "20px", color: "Green/500", strokeWidth: "bold" }) }), _jsx(Typography, { variant: "text-sm-regular", sx: itemTextSx, children: strength.replace(/\//g, '/\u200B') })] }, "strength-".concat(index))); }) }), _jsx(Box, { sx: sectionContainerSx(isMobile, isEmptyState), children: !isEmptyState &&
                            opportunitiesToGrow.map(function (opportunity, index) { return (_jsxs(Box, { sx: itemContainerSx, children: [_jsx(Box, { sx: iconContainerOpportunitySx, children: _jsx(AppIcon, { iconName: "Target03", diameter: "24px", color: "Colors/Foreground/fg-brand-primary" }) }), _jsx(Typography, { variant: "text-sm-regular", sx: itemTextSx, children: opportunity.replace(/\//g, '/\u200B') })] }, "opportunity-".concat(index))); }) })] })] }));
};
var unlockItemContainerSx = function (isMobile, isEmptyState) {
    if (isEmptyState === void 0) { isEmptyState = false; }
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            width: '100%',
            alignItems: 'stretch',
            gap: isMobile ? 0 : backrs.spacing['spacing-2xl'],
            backgroundColor: backrs.colors['Colors/Base/White'],
            borderTop: "1px solid ".concat(isEmptyState ? backrs.colors['Colors/Foreground/fg-quinary'] : backrs.colors['Colors/Foreground/fg-secondary']),
        });
    };
};
var imageContainerSx = function (isMobile) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            width: isMobile ? '100%' : IMAGE_COLUMN_WIDTH,
            flexShrink: 0,
            display: 'flex',
            alignItems: isMobile ? 'center' : 'stretch',
            flexDirection: isMobile ? 'row' : 'column',
            gap: isMobile ? '12px' : 0,
            padding: isMobile ? '0' : 0,
            maxHeight: isMobile ? '100px' : '100%',
            backgroundColor: backrs.colors['Blue/100'],
            justifyContent: 'center',
        });
    };
};
var unlockItemImageSx = function (isMobile, isEmptyState) {
    if (isEmptyState === void 0) { isEmptyState = false; }
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ height: '100%', width: '90%', objectFit: 'cover', opacity: isEmptyState ? 0.3 : 1 }, (!isMobile && {
            borderRight: "1px solid ".concat(isEmptyState ? backrs.colors['Colors/Foreground/fg-quinary'] : backrs.colors['Colors/Foreground/fg-secondary']),
            borderTop: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-quinary']),
            height: '100%',
            maxHeight: '100%',
            width: '100%',
            objectFit: 'cover',
        })));
    };
};
var tableContainerSx = function (isMobile) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            flex: 1,
            gap: isMobile ? 0 : backrs.spacing['spacing-2xl'],
            alignItems: 'flex-start',
        });
    };
};
var categoryColumnSx = function (isMobile, isEmptyState) {
    if (isEmptyState === void 0) { isEmptyState = false; }
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', height: '100%', minWidth: NAME_COLUMN_WIDTH, maxWidth: NAME_COLUMN_WIDTH, minHeight: MIN_HEIGHT }, (isMobile && {
            padding: backrs.spacing['spacing-2xl'],
            width: '100%',
            minWidth: 'auto',
            maxWidth: 'none',
            minHeight: 'auto',
            borderTop: "1px solid ".concat(isEmptyState ? backrs.colors['Colors/Foreground/fg-quinary'] : backrs.colors['Colors/Foreground/fg-secondary']),
        })));
    };
};
var sectionContainerSx = function (isMobile, isEmptyState) {
    if (isEmptyState === void 0) { isEmptyState = false; }
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({ display: 'flex', flexDirection: 'column', flex: 1, gap: backrs.spacing['spacing-sm'], padding: backrs.spacing['spacing-2xl'], alignItems: 'flex-start', minWidth: 0 }, (isMobile && {
            width: '100%',
            borderTop: "1px solid ".concat(isEmptyState ? backrs.colors['Colors/Foreground/fg-quinary'] : backrs.colors['Colors/Foreground/fg-secondary']),
        })));
    };
};
var itemContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-sm'],
        width: '100%',
        minWidth: 0,
    });
};
var iconContainerOpportunitySx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};
var iconContainerStrengthSx = __assign(__assign({}, iconContainerOpportunitySx), { marginTop: '0px', marginBottom: '-2px' });
var itemTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-primary'],
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
    });
};
var unlockItemTitleSx = function (_a) {
    var typography = _a.typography;
    return (__assign({ fontStyle: 'italic', fontWeight: 500 }, typography['text-sm-regular']));
};
